import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ButtonVariationEnum } from '../../../ui/Button/types';
import i18n from '../../../utils/i18n';
import Button from '../../../ui/Button';
import Popup, { PopupSize } from '../../../ui/Popup/Popup';
import { useFetchGet } from '../../../utils/fetch/useFetchGet';
import { pathsApi } from '../../../router/paths';
import { IProductShort } from '../../ProductAll/types';
import Loading from '../../../ui/Loading';
import DragAndDropPopup from '../../../components/DragAndDrop/dragAndDropPopup';
import { FetchApi } from '../../../utils/fetch/fetchApi';
import { AppDispatch } from '../../../state';
import { setNotificationSuccess } from '../../../state/reducers/notification';

interface ISortProduct {
    categoryId: number;
}

const SortProductsPopup = ({ categoryId, handleClose }: ISortProduct & { handleClose: () => void }) => {
    const { data } = useFetchGet<Array<IProductShort>>({
        path: pathsApi.productByCategory,
        search: new URLSearchParams({ category: String(categoryId) }).toString(),
    });
    const dispatch = useDispatch<AppDispatch>();

    const handleSaveSort = async (payload: Array<{ id: number; order: number }>) => {
        const response = await FetchApi.post<{ success: boolean }>(pathsApi.productSort, {
            items: payload,
        });

        if (response?.success) {
            dispatch(setNotificationSuccess(i18n.general.updatedSuccessful));
            handleClose();
            return true;
        }
        return false;
    };

    if (!data) {
        return (
            <Popup title={i18n.general.sort} close={handleClose} size={PopupSize.m}>
                <Loading isFullScreen={false} />
                <Button onClick={handleClose} variation={ButtonVariationEnum.SOFT}>
                    {i18n.general.cancel}
                </Button>
            </Popup>
        );
    }

    if (!data.length) {
        return (
            <Popup title={i18n.general.sort} close={handleClose} size={PopupSize.m}>
                <p>{i18n.category.productsNotFound}</p>
                <Button onClick={handleClose} variation={ButtonVariationEnum.SOFT}>
                    {i18n.general.cancel}
                </Button>
            </Popup>
        );
    }

    return (
        <DragAndDropPopup
            isOpen={true}
            handleClose={handleClose}
            items={data
                ?.sort((a, b) => a.order - b.order)
                .map((item) => ({
                    id: item.id,
                    content: [item.brand?.name, item.name, '(', item.sub_name, ')'].filter(Boolean).join(' '),
                }))}
            submit={handleSaveSort}
        />
    );
};

const SortProduct = ({ categoryId }: ISortProduct) => {
    const [isOpen, handleOpen] = useState<boolean>(false);

    return (
        <>
            <Button
                onClick={() => {
                    handleOpen(true);
                }}
                variation={ButtonVariationEnum.SOFT}
            >
                {i18n.category.changeProductsOrder}
            </Button>
            {isOpen && <SortProductsPopup categoryId={categoryId} handleClose={() => handleOpen(false)} />}
        </>
    );
};

export default SortProduct;
